import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const PageTransition = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsVisible(false);
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div 
      className={`transition-all duration-500 ease-out ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-4'
      }`}
    >
      {children}
    </div>
  );
};

export const FadeTransition = ({ children, show = true, duration = 300 }) => {
  return (
    <div 
      className={`transition-all duration-${duration} ease-out ${
        show 
          ? 'opacity-100 scale-100' 
          : 'opacity-0 scale-95'
      }`}
    >
      {children}
    </div>
  );
};

export const SlideTransition = ({ 
  children, 
  show = true, 
  direction = 'up',
  duration = 300 
}) => {
  const directionClasses = {
    up: show ? 'translate-y-0' : 'translate-y-4',
    down: show ? 'translate-y-0' : '-translate-y-4',
    left: show ? 'translate-x-0' : 'translate-x-4',
    right: show ? 'translate-x-0' : '-translate-x-4'
  };

  return (
    <div 
      className={`transition-all duration-${duration} ease-out ${
        show ? 'opacity-100' : 'opacity-0'
      } ${directionClasses[direction]}`}
    >
      {children}
    </div>
  );
};